import Icon from '@components/icon/Icon';
import { Button } from '@trussworks/react-uswds';
import { mdiArrowDownCircleOutline, mdiArrowUpCircleOutline } from '@mdi/js';

import './SectionButton.scss';

const SectionButton = ({ location, onClick, onKeyup, section }) => {
  const text = location === 'bottom' ? 'Next' : 'Previous';
  const iconPath = location === 'bottom' ? mdiArrowDownCircleOutline : mdiArrowUpCircleOutline;
  const className = location === 'bottom' ? 'next' : 'prev';

  return (
    <Button
      className={`section-button button-small ${className}`}
      id='section'
      onClick={onClick}
      onKeyUp={onKeyup}
      type='button'
    >
      <Icon focusable={false} size='20px' path={iconPath} />
      <span className='section-label'>{text} Section:</span>
      <span className='section-text'>{section}</span>
    </Button>
  );
};

export default SectionButton;
